import{createRenderBatcher as e}from"./batcher.mjs.js";const{schedule:c,cancel:o}=e(queueMicrotask,!1);export{o as cancelMicrotask,c as microtask};
